import React, { useState } from 'react';
import { Image } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';
import { FallbackCard } from '@components/atoms/FallbackCard/FallbackCard';
import { ShowAllTitle } from '@components/atoms/ShowAllTitle/ShowAllTitle';
import { Carousel } from '@components/molecules/Carousel/Carousel';
import { GrowingElement } from '@components/molecules/GrowingElement/GrowingElement';

export const PageContentElementTvmCustomLane = (element) => {
  const [lastScroll, setLastScroll] = useState(0);
  if (!element?.customItems) return null;
  return (
    <div className="relative pl-4 sm:pl-8 lg:pl-16">
      <ShowAllTitle title={element.title} link={element.title_link} />
      <section className="space-y-32">
        <Carousel
          onScrollComplete={() => {
            setLastScroll((prev) => prev + 1);
          }}
        >
          {element?.customItems?.map((item) => (
            <GrowingElement
              lastScroll={lastScroll}
              link={item?.link}
              key={item?.id}
              topSlot={
                <>
                  {item?.image?.url ? (
                    <Image
                      src={item?.image.url}
                      alt={item?.title}
                      width={350}
                      height={200}
                      copyright=""
                      imageMode="cover"
                      classProps={{
                        container: twMerge('absolute inset-0 rounded-t-lg overflow-hidden'),
                      }}
                    />
                  ) : (
                    <FallbackCard classProps={{ root: 'overflow-hidden rounded-t-lg' }} />
                  )}
                </>
              }
              bottomSlot={
                <>
                  <div className="grid w-full gap-1 p-2 transition-spacings duration-150 canhover:group-hover:px-4 canhover:group-hover:pt-3">
                    <div className="font-herokid font-medium">{item?.title}</div>
                    <div className="label-sm">{item?.subheadline}</div>
                  </div>
                </>
              }
            />
          ))}
        </Carousel>
      </section>
    </div>
  );
};

export default PageContentElementTvmCustomLane;
